import { EntityDialog } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { Authorization, Config, ErrorHandling } from "@serenity-is/corelib/q";
import { IdleTimeout } from "@serenity-is/pro.extensions";
import { siteLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('CIMS');
EntityDialog.defaultLanguageList = siteLanguageList;
gridDefaults.useCssVars = true;

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

$(() => {
    if (window.location.pathname.indexOf('Samples/IdleTimeout') > 0)
        return;

    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        // 기본 activityTimeout 값 설정
        var activityTimeout = 15 * 60;

        new IdleTimeout({
            activityTimeout: activityTimeout,
            warningDuration: 2 * 60
        });
    }

    $.ajax({
        url: '/Administration/getSessionDuration',
        type: 'POST',
        success: function (data) {
            // 가져온 데이터(data)를 기반으로 warningDuration 값을 설정
            var time = Number(data);
            // activityTimeout 값을 가져온 데이터로 변경
            activityTimeout = !isNaN(time) ? time * 60 : activityTimeout;

            // 변경된 activityTimeout 값을 사용하여 IdleTimeout 초기화
            new IdleTimeout({
                activityTimeout: activityTimeout,
                warningDuration: 2 * 60
            });
        },
        error: function (xhr, status, error) {

            console.error(error);
        }
    });
});

